// Webpack
import "bootstrap";
import dayjs from "dayjs";
import initBudoux from "./modules/initBudoux";
import initSwiper from "./modules/initSwiper";
import Alpine from "alpinejs";
import focus from "@alpinejs/focus";
import headerChildren from "./modules/headerChildren.js";
import mobileNavigation from "./modules/mobileNavigation.js";
import fetchMessage from "./modules/fetchMessage.js";

window.dayjs = dayjs;

initBudoux();
initSwiper();

Alpine.plugin(focus);
Alpine.data("headerChildren", headerChildren);
Alpine.data("fetchMessage", fetchMessage);
Alpine.store("mobileNavigation", mobileNavigation());

window.Alpine = Alpine;
Alpine.start();
